export default __webpack_public_path__ + "static/pro@992_2x-c7549d1b4abf0214f1e0c68936f7fdf7.webp";